export default "__VITE_ASSET__CNKqgD5U__"